/** ดาบดันผา (lane C3 skeleton): kiln-hot red cliff, fire + brown rock, glowing chips (blood -> ember 10-13). Built from swordKit via families/swordArtGen.ts; polish later. */
import { makeArt } from '../families/swordArtGen';

export const REDCLIFF_FX: ReturnType<typeof makeArt> = makeArt('cliff-push-sabre', { a: 'fire', b: 'brown', motif: 'chips' }, [
  ['rc-edge', 'lock'],
  ['rc-split', 'break'],
  ['rc-tide', 'sweep', 5],
  ['rc-hunt', 'thrust', 56],
  ['rc-reap', 'slash'],
  ['rc-cliff', 'buff'],
  ['rc-drink', 'heal'],
  ['rc-sea', 'power', 4],
]);
